import React from 'react'
import { Stack, type SxProps, type Theme, Typography } from '@mui/material'

import { type IconName } from '~components/icons'
import { lightTokens } from '~tokens/internal'

import Avatar from '../Avatar'
import Button, { type StyledButtonProps } from '../Button/Button'
import Icon, { type SemanticIconName } from '../Icon'

import './EmptyState.scss'

export interface EmptyStateProps {
  iconName?: SemanticIconName | IconName
  title: string
  description?: string
  buttonLabel?: string
  onButtonClick?: () => void
  buttonProps?: Omit<StyledButtonProps, 'onClick' | 'children'>
  variant?: 'default' | 'micro'
  sx?: SxProps<Theme>
}

const EmptyState: React.FC<EmptyStateProps> = ({
  iconName,
  title,
  description,
  buttonLabel,
  onButtonClick,
  buttonProps,
  variant = 'default',
  sx,
}) => {
  return (
    <Stack
      className={`internal-empty-state ${variant === 'micro' ? 'internal-empty-state--micro' : ''}`}
      sx={sx}
    >
      {iconName &&
        (variant === 'micro' ? (
          <Icon name={iconName} color={lightTokens.text.secondary} />
        ) : (
          <Avatar iconName={iconName} size='lg' />
        ))}
      <Typography variant='h5' className='internal-empty-state__title'>
        {title}
      </Typography>
      {description && (
        <Typography variant='body2' className='internal-empty-state__description'>
          {description}
        </Typography>
      )}
      {buttonLabel && (
        <Button onClick={onButtonClick} {...buttonProps}>
          {buttonLabel}
        </Button>
      )}
    </Stack>
  )
}

export default EmptyState
